import Markdown from '@boyuai/markdown';

export default Markdown;
